import React from 'react';
import {useAppSelector} from "common/hook";
import {getCabinetData} from "entities/Cabiner/model/selectors/getCabinetData/getCabinetData";
import {PAST_LESSONS} from "entities/constants/constants";
import {NothingYetMessage} from "../../../../nothing-yet-message/NothingYetMessage";
import {NavLink} from "react-router-dom";


export const PastClassesCart = () => {
    const cabinetData = useAppSelector(getCabinetData)


    return (
        <div className="info-card">
            <div className="info-card-hdr">
                <div className="title-box">
                    <p className="info-card-title h4">{PAST_LESSONS}</p>
                </div>
                {cabinetData?.pastLessons &&
                    <span className="sub-data">{cabinetData?.pastLessons.month}</span>
                }
            </div>
            {cabinetData?.pastLessons && cabinetData?.pastLessons.items.length > 0 ? (
                <div className="info-card-content">
                    {cabinetData?.pastLessons.items.slice(0, 4).map((pastClass, index) => (
                        <div className="row" key={index}>
                            <p>
                                <NavLink to={`/groups/${pastClass.group.id}/lessons/${pastClass.id}`}>
                                    {pastClass.title}
                                </NavLink>
                            </p>
                            <div className="group-item-data">
                                <time className="new-time">
                                    <span>{pastClass.date},</span>
                                    <span>{pastClass.time}</span>
                                </time>
                                <p>
                                    <NavLink to={`/groups/${pastClass.group.id}`}>
                                        {pastClass.group.title}
                                    </NavLink>
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="info-card-content">
                    <NothingYetMessage/>
                </div>
            )}
        </div>
    );
}
